import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "subbody modulewrap"
};
const _hoisted_2 = {
  class: "subcontact"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "mapwrap"
}, [/*#__PURE__*/_createElementVNode("iframe", {
  width: "600",
  height: "400",
  frameborder: "0",
  scrolling: "no",
  marginheight: "0",
  marginwidth: "0",
  src: "https://surl.amap.com/1L1IGvtdm9dh"
})], -1);
const _hoisted_4 = ["innerHTML"];
import { FFmixin } from "@/mixin/mixin.js";
export default {
  __name: 'contact',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const {
      setTitle,
      getNavData,
      navData
    } = FFmixin();
    const getData = async () => {
      setTitle(2, 0, 260, () => {
        getNavData();
      });
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
        class: "contactinfo editor",
        innerHTML: _ctx.$common.langInfo(_unref(navData).navContent.content, _unref(navData).navContent.content_en)
      }, null, 8, _hoisted_4)])]);
    };
  }
};